import dayjs from 'dayjs'

export const DATE_FORMAT = 'yyyy-MM-dd'

export function formatDateToUTC(dateString) {
  const date = dayjs(dateString)
  return date.format(DATE_FORMAT)
}

export function formatDateToYMD(input: string | Date): string {
  const date = new Date(input)
  if (isNaN(date.getTime())) return '' // handle invalid date

  console.log('input', input)

  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')

  const result = `${yyyy}-${mm}-${dd}`

  console.log('input,result', input, result)

  return result
}
